import {
  excludeArchivedEntities,
  isArchivedEntity,
  type ArchiveLifecycleSource,
} from '@terra/shared-dto-types';

type TracePreviewArchiveSource = ArchiveLifecycleSource & {
  signal?: ArchiveLifecycleSource | null;
};

export const isArchivedTracePreview = (
  trace: TracePreviewArchiveSource | null | undefined,
): boolean => isArchivedEntity(trace) || isArchivedEntity(trace?.signal);

export const excludeArchivedTracePreviews = <
  T extends TracePreviewArchiveSource,
>(
  traces: readonly T[],
): T[] => excludeArchivedEntities(traces, isArchivedTracePreview);
